import request from './request'

export default {
    getDetail: data => request.get(`https://www.wangjiahepark.top/prod-api/attractions/getAttractionsById/${data}`),
    getList: data => request.post(`https://www.wangjiahepark.top/prod-api/attractions/getAttractionsList`, data)
    // getDetail: data => request.get(`http://localhost/dev-api/attractions/getAttractionsById/${data}`),
    // getList: data => request.post(`http://localhost/dev-api/attractions/getAttractionsList`, data)
}